module.exports = __webpack_public_path__ + "img/43_37.6a9c692d.png";